import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import BASE_URL from "../BaseUrl.jsx";
export default function TeacherSlider({ teachers }) {
  const [[page, direction], setPage] = useState([0, 0]);

  const paginate = (newDirection) => {
    setPage(([prevPage]) => {
      const next =
        (prevPage + newDirection + teachers.length) % teachers.length;
      return [next, newDirection];
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      paginate(1);
    }, 5000);

    return () => clearInterval(interval);
  }, [page]);

  const teacher = teachers[page];

  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 300 : -300,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (direction) => ({
      x: direction > 0 ? -300 : 300,
      opacity: 0,
    }),
  };

  return (
    <div className="relative w-full  overflow-hidden text-center items-center justify-center">
      <div className="relative w-full  overflow-hidden text-center items-center justify-center bg-white">
      <h3 style={{textAlign: "center", padding: "0px", marginTop: "0px", marginBottom: '30px'}}>باقة من أفضل المدرسين</h3>
      </div>
      <AnimatePresence custom={direction} mode="wait">
        <motion.div
          key={page}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ duration: 0.5 }}
          drag="x"
          dragConstraints={{ left: 0, right: 0 }}
          dragElastic={0.5}
          onDragEnd={(e, info) => {
            if (info.offset.x < -100) {
              paginate(1);
            } else if (info.offset.x > 100) {
              paginate(-1);
            }
          }}
          className="bg-white rounded-xl p-6 flex flex-col md:flex-row items-center content-center text-center "
        >
          <img
  src={`${BASE_URL}/teacher/best-image?image=${teacher.image}`}
  alt={teacher.name}
  style= {{maxWidth: "250px", maxHeight: "250px", borderRadius: "5%"}}
/>

          <div style={{height: "250px"}}>
            <h2 className="text-2xl font-bold">{teacher.name}</h2>
            <p className="mt-2 text-gray-600 mb-0 ">
              {teacher.description}
            </p>
          </div>
        </motion.div>
      </AnimatePresence>
      
    </div>
  );
}